<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
            class="float-right"
            @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>
        {{this.rsvpData && this.isUpdate? 'Update' :'Add' }} RSVP
      </h3>
      <b-row>
        <b-col v-if="false">
          <b-img
            v-if="formRSVP && formRSVP.imgURL"
            :src="formRSVP.imgURL"
            fluid
            style="object-fit: contain"
            :alt="`My Memory with Derriana`"
          />
          <image-upload
            v-else
            ref="image-upload"
            class="photo-upload-wrapper"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="false"
            :show-delete="true"
            text-drag="Click to upload or drag photo memory (.png, .jpg) here. "
            @img-uploaded-url="handlePhotoUploadedURL"
          />
        </b-col>
        <b-col>
          <!-- NAME -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Name"
              label-info=""
            />
            <b-form-input
              v-model="formRSVP.name"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Guest Name"
            />
          </b-form-group>
          <!-- URL -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Guest Email"
              label-info=""
            />
            <b-form-input
              v-model="formRSVP.email"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Guest Email"
            />
          </b-form-group>
          <!-- DESCRIPTION (OPT)-->
          <b-form-group
            id="input-group-1"
            label="Notes:"
            label-for="input-note"
            style="margin-top: 25px;"
            description="Copy and Paste"
          >
            <transition name="fadeHeight" mode="out-in">
              <editor
                id="textarea-default"
                v-show="formRSVP"
                @input="input"
                :clear="clear"
                :content="formRSVP.note"
                @resetClear="resetClear"
              />
            </transition>
          </b-form-group>
          <span class="error">
            <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
              {{ anError }}
            </div>
          </span>
          <b-form-group>
            <b-button
              v-if="this.rsvpData && this.isUpdate"
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleUpdateRSVPClick"
            >
              Update
              {{ formRSVP && formRSVP.name ? formRSVP.name : "your Guest" }}
            </b-button>
            <b-button
              v-else
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleAddRSVPClick"
            >
              Add {{ formRSVP && formRSVP.name ? formRSVP.name : " Guest" }}
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import axios from "axios";
export default {
  name: "Admin_Manage_AddEditItem_RSVPs",
  mixins: [UploadImage, VideoHandling],
  components: {
    Modal,
    CloseButton,
    ImageUpload,
    Editor
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemStatusModalId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  created() {
    this.formReset();
  },
  mounted() {},
  methods: {
    handleAddItem() {
      this.isUpdate = false;
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleUpdateItem(rsvpData) {
      debugger;
      this.isUpdate = true;
      this.rsvpData = rsvpData;
      this.formRSVP = rsvpData && rsvpData.form ? _.clone(rsvpData.form) : {};
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    handlePhotoUploadedURL(idx, url) {
      this.formRSVP.imgURL = url;
    },
    handleAddRSVPClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/submitRSVP", {
            form: this.formRSVP,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    handleUpdateRSVPClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/updateRSVP", {
            id: this.rsvpData && this.rsvpData.id ? this.rsvpData.id : null,
            form: this.formRSVP,
            ip
          })
          .then(res => {
            this.$emit("item-updated");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    simpleValidate() {
      this.errors = [];

       if (this.formRSVP && !this.validateEmail(this.formRSVP.email))
         this.errors.push("Please enter a valid email");

      if (
        (this.formRSVP && !this.formRSVP.name) ||
        this.formRSVP.name.length === 0
      )
        this.errors.push("Please enter guest name");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formRSVP = null;
      this.formRSVP = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    },
    input(val) {
      this.formRSVP.note = val.content;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      status: null, //|all | submitted | needs_work | inactive
      clear: false,
      idx: 0,
      storagePath: "derriana_rsvps_imgs",
      isUpdate: false,
      rsvpData: null,
      formRSVP: null,
      formDefault: {
        name: null,
        note: [],
        email: null,
        comment: null,
        imgURL: null
      },
      errors: [],
      entity: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
